import axios from 'axios';
import get from 'lodash/get';
import qs from 'query-string';

// Libs
import { Consequence, parseUrl, thunkHandler, thunkErrorHanlder } from '../../libs/utils';

// Endpoints
import { CLIENT_REDIRECT, CLIENT_DETAIL, CLIENT_PROVIDER, CLIENT_INVOICES_FROM_UUID, CLIENT_INVOICES, CLIENT_SETTINGS, CLIENT_INVOICE_BALANCE, CLIENT_TAX, CLIENT_COUNTRY_REGION } from '../../constants/endpoints';

// ActionTypes
export const NEW_CLIENT_DETAIL      = 'NEW_CLIENT_DETAIL';
export const NEW_PROVIDER_DETAIL    = 'NEW_PROVIDER_DETAIL';
export const NEW_PORTAL_INVOICES    = 'NEW_PORTAL_INVOICES';
export const NEW_INVOICES_TO_PAY    = 'NEW_INVOICES_TO_PAY';
export const NEW_PAYMENT_METHODS    = 'NEW_PAYMENT_METHODS';
export const NEW_CLIENT_SETTINGS    = 'NEW_CLIENT_SETTINGS';
export const NEW_INVOICE_BALANCE    = 'NEW_INVOICE_BALANCE';
export const CLIENT_TAXES_LIST      = 'CLIENT_TAXES_LIST';
export const SELECT_NOTE_TO_INVOICE = 'SELECT_NOTE_TO_INVOICE';

export function redirectClient(uuid) {
  return axios.get(parseUrl(CLIENT_REDIRECT, { uuid }))
}

export function getClientMeta(clientUuid, currency) {
  return dispatch => axios.get(parseUrl(CLIENT_DETAIL, { uuid: clientUuid }, {currency: currency ? currency : 'MXN'}))
  .then(res  => new Consequence({
    dispatch,
    payload: { data: get(res, 'data.data', {}) },
    eventTypes: { success: NEW_CLIENT_DETAIL, error: 'ERROR' }
  }))
  
} // END getClientMeta

export function updateClient(clientUuid, payload) {
  return dispatch => axios.put(parseUrl(CLIENT_DETAIL, { uuid: clientUuid }), payload)
    .then(() => axios.get(parseUrl(CLIENT_DETAIL, { uuid: clientUuid })))
    .then(res  => new Consequence({
      dispatch,
      payload: { data: get(res, 'data.data', {}) },
      eventTypes: { success: NEW_CLIENT_DETAIL, error: 'ERROR' }
    }))

} // END updateClient

export function getProviderMeta(clientUuid) {
  return dispatch => axios.get(parseUrl(CLIENT_PROVIDER, { uuid: clientUuid }))
    .then(res  => new Consequence({
      dispatch,
      payload: { data: get(res, 'data.data', {}) },
      eventTypes: { success: NEW_PROVIDER_DETAIL, error: 'ERROR' }
    }))

} // END getClientMeta

export function getClientInvoicesFromUuids(clientUuid, invoicesUuids) {
  return dispatch => axios.get(`${parseUrl(CLIENT_INVOICES_FROM_UUID, { uuid: clientUuid })}?q=${invoicesUuids}`)
    .then(res => new Consequence({
      dispatch,
      payload: { data : get(res, 'data.data', []) },
      eventTypes: { success: NEW_INVOICES_TO_PAY, error: 'ERROR' }
    }))

} // END getClientInvoicesFromUuids

let timeout;
export function getClientUnpaidInvoices(clientUuid, params) {
  clearTimeout(timeout);
  return new Promise((resolve) => {
    timeout = setTimeout (() => {
      if (typeof params !== "object" && !Array.isArray(params)) params = {};
      const { code } = params;
      const qsObj = {};

      qsObj.filter = 'to_pay' // deafult filter
      if (code) qsObj.code = code;

      return resolve(dispatch => axios.get(`${parseUrl(CLIENT_INVOICES, { uuid: clientUuid })}?${qs.stringify(qsObj)}`)
        .then(res => new Consequence({
          dispatch,
          payload: { data : get(res, 'data.data', {})},
          eventTypes: { success: NEW_PORTAL_INVOICES, error: 'ERROR'}
        }))
      )
    })
  })
} // END getClientUnpaidInvoices

export function updateInvoicesToPay(invoices) {
  return {
    type: NEW_INVOICES_TO_PAY,
    payload : invoices
  }
} // END updateInvoicesToPay

export function updatePaymentMethods(paymentMethods) {
  return {
    type: NEW_PAYMENT_METHODS,
    payload : paymentMethods
  }
} // END updatePaymentMethods

export function getClientSettings(clientUuid) {
  return dispatch => axios.get(parseUrl(CLIENT_SETTINGS, { uuid: clientUuid }))
    .then(res  => new Consequence({
      dispatch,
      payload: { data: get(res, 'data.data', {}) },
      eventTypes: { success: NEW_CLIENT_SETTINGS, error: 'ERROR' }
    }))

} // END getClientMeta

export function getClientInvoiceBalance(clientUuid, invoicesUuid) {
  return dispatch => axios.get(parseUrl(CLIENT_INVOICE_BALANCE, {uuid: clientUuid, invoice: invoicesUuid}))
    .then(res  => new Consequence({
      dispatch,
      payload: { data: get(res, 'data.data', {}) },
      eventTypes: { success: NEW_INVOICE_BALANCE, error: 'ERROR' }
    }))

} // END getClientMeta

export function getClientTax(uuid, params, options) {
  const page = get(params, 'page', 1);
  const mainTax = get(options, 'mainTax');
  const prevData = get(options, 'prevData');
  let payload = []

  if(mainTax) {
    payload = [mainTax]
  } else {
    payload = [...prevData]
  }

  return dispatch => axios.get(parseUrl(CLIENT_TAX, { uuid }, { page }))
    .then(res  => new Consequence({
      dispatch,
      payload: { data : { taxes: [...payload, ...get(res, 'data.data', [])], pagination: get(res, 'data.paginate')} },
      eventTypes: { success: CLIENT_TAXES_LIST, error: 'ERROR' }
    }))

} // END getClientTax

export function createNewClientTax(uuid, body, options) {
  const taxesList = get(options, 'taxesList');
  const pagination = get(options, 'pagination');

  return dispatch => axios.post(parseUrl(CLIENT_TAX, { uuid }), body)
    .then(res  => new Consequence({
      dispatch,
      payload: { data: { taxes: [...taxesList, get(res, 'data.data', [])], pagination } },
      eventTypes: { success: CLIENT_TAXES_LIST, error: 'ERROR' }
    }))

} // END createNewClientTax


export function deleteClientTax(uuid, id_tax, options) {
  const taxesList = get(options, 'taxesList');
  const pagination = get(options, 'pagination');

  return dispatch => axios.delete(parseUrl(CLIENT_TAX_DELETE, { uuid, tax_uuid: id_tax }))
    .then(()  => new Consequence({
      dispatch,
      payload: { data: { taxes: [...taxesList], pagination } },
      eventTypes: { success: CLIENT_TAXES_LIST, error: 'ERROR' }
    }))

} // END deleteClientTax


export function updateNoteToInvoice(invoice) {
  return dispatch => Promise.resolve(dispatch({
    type: SELECT_NOTE_TO_INVOICE,
    payload : invoice
  }))
} // END updateNoteToInvoice

export function getPortalCountryRegion(region) {
  function parseDistrictData(data){
    if (Array.isArray(data)) return data.map(el => ({ value: el.name, label: el.name }))
    else return null;

  } // END parseDistrictData

  return dispatch  => axios.get(parseUrl(CLIENT_COUNTRY_REGION, { region }))
    .then(res => thunkHandler(dispatch, parseDistrictData(get(res, 'data.data')), null, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END getPortalCountryRegion



// WEBPACK FOOTER //
// ./src/redux/actions/portalActions.js